import { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const inflight = new Map();   // token -> promise; survives remounts so the single-use token is only consumed once
const consume = (token) => {
  if (!inflight.has(token)) inflight.set(token, api.post("/auth/magic-link/consume", { token }).then((r) => r.data));
  return inflight.get(token);
};

export default function MagicLink() {
  const [params] = useSearchParams();
  const [err, setErr] = useState("");
  const { setUser } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setErr("This sign-in link is missing its token."); return undefined; }
    let alive = true;
    consume(token)
      .then((data) => { if (!alive) return; setUser(data); navigate(data.role === "employee" ? "/me" : data.role === "client" ? "/client" : "/dashboard", { replace: true }); })
      .catch((e) => { if (alive) setErr(apiErr(e)); });
    return () => { alive = false; };
  }, [params, setUser, navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fafafa] p-6">
      <div className="w-full max-w-sm bg-white border border-border p-8 text-center" data-testid="magic-link-page">
        {!err ? (
          <><div className="mx-auto h-8 w-8 border-2 border-black border-t-transparent rounded-full animate-spin" /><p className="mt-4 text-sm text-muted-foreground">Signing you in…</p></>
        ) : (
          <>
            <h1 className="text-xl font-black">Sign-in link problem</h1>
            <p data-testid="magic-link-error" className="mt-3 text-sm text-destructive">{err}</p>
            <div className="mt-6 flex flex-col gap-2 text-sm">
              <Link to="/login?mode=magic" data-testid="magic-link-retry" className="bg-black text-white py-2.5 font-medium hover:bg-neutral-800">Request a new link</Link>
              <Link to="/employee/login?mode=magic" className="text-muted-foreground underline underline-offset-2">Employee portal</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
